import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcHelpGrid]'
})
export class HelpGridDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
